<template>
    <div class="flex h-full max-h-[400px] w-full flex-col">
        <div class="flex flex-1 items-center justify-center">
            <div :class="canvasClass">
                <canvas
                    ref="canvas"
                    class="h-full w-full bg-white"
                />
            </div>
        </div>
        <div class="mt-4">
            {{ helpText }}
        </div>
    </div>
</template>

<script setup lang="ts">
import { onMounted, onUnmounted, ref } from 'vue'
import SignaturePad from 'signature_pad'

defineProps<{ helpText: string; canvasClass: string }>()

const emit = defineEmits({
    data: (payload: string) => typeof payload === 'string'
})

const canvas = ref<HTMLCanvasElement>()
let signaturePad: SignaturePad | undefined
function resizeCanvas() {
    if (signaturePad === undefined || canvas.value === undefined) {
        return
    }
    const ratio = Math.max(window.devicePixelRatio || 1, 1)
    canvas.value.width = canvas.value.offsetWidth * ratio
    canvas.value.height = canvas.value.offsetHeight * ratio
    canvas.value.getContext('2d').scale(ratio, ratio)
    signaturePad.clear()
    emit('data', '')
}

onMounted(() => {
    signaturePad = new SignaturePad(canvas.value)
    signaturePad.addEventListener('endStroke', () => {
        if (signaturePad === undefined) {
            emit('data', '')
            return
        }

        emit('data', signaturePad.isEmpty() ? '' : signaturePad.toDataURL())
    })

    resizeCanvas()
    window.addEventListener('resize', resizeCanvas)
})

onUnmounted(() => {
    window.removeEventListener('resize', resizeCanvas)
    signaturePad?.off()
})
</script>
